import React from "react";
import styles from "./InvitePopup.module.less";
import useDialogManager from "@/utils/useDialogManager";
import { getCountryAsset } from "@/utils/countryAssetUtils";
import MarketingImagePopup from "@/features/common/marketingPopup";
interface InvitePopupProps {
    onClose: () => void;
}

const InvitePopup: React.FC<InvitePopupProps> = ({onClose}) => {
    const popupimg = getCountryAsset("invitePopup");
    const {
        openSignIn,
        openSignUp,
        openWallet,
        openVip,
        openDialogInviteWheel,
        openTaskCenter,
        openWheel,
        openBetting,
        openFarm,
    } = useDialogManager();

    const handleClick = () => {
        onClose();
        openDialogInviteWheel();
    };

    return (
        <MarketingImagePopup
            imageSrc={popupimg}
            imageAlt="invite"
            onImageClick={handleClick}
            onClose={onClose}
            imageClassName={styles.image}
        />
    );
};

export default InvitePopup;
